import IState from '../models/IState';
import { createSelector } from "reselect";

export const isAuthSelector = createSelector(
    (state: IState) => state.auth.token,
    (token) => {
        return token ? true : false
    }
)

